// Mesaj balonu — hasta konuşması ve "Yeni kişiler" konusu ortak kullanır.
// WhatsApp mesajlarında küçük kanal ikonu; klinik gönderiminde teslim tiki (waStatus).

import React from "react";
import { Box, Tooltip, Typography, alpha } from "@mui/material";
import { WhatsApp as WhatsAppIcon, Done as DoneIcon, DoneAll as DoneAllIcon } from "@mui/icons-material";
import { ACCENTS, COLORS, TYPO } from "../../styles/uiConstants";
import { waStatusInfo } from "../../constants/whatsapp";
import { timeOf } from "./messageFormat";

/** Mesajın bizden mi gittiği: sunucu `mine` ya da yeni kişi mesajında `direction`. */
export const isMine = (m) => (typeof m?.mine === "boolean" ? m.mine : m?.direction === "out");
const waStatusOf = (m) => m?.waStatus ?? m?.wa?.status ?? null;

function WaTicks({ status }) {
  const info = waStatusInfo(status);
  if (!info) return null;
  if (info.tone === "error") {
    return (
      <Box component="span" sx={{ color: COLORS.errorDark, ml: 0.5 }}>
        · Gönderilemedi
      </Box>
    );
  }
  const Icon = info.ticks === 2 ? DoneAllIcon : DoneIcon;
  return (
    <Tooltip title={info.label}>
      <Icon
        aria-label={info.label}
        sx={{
          fontSize: 14,
          ml: 0.5,
          verticalAlign: "-3px",
          color: info.tone === "read" ? ACCENTS.blue : COLORS.slate400,
        }}
      />
    </Tooltip>
  );
}

/**
 * @param {object} message - { text, createdAt, mine|direction, senderName, readAt, channel, waStatus }
 * @param {object} palette
 * @param {boolean} [showChannel=true] - WhatsApp ikonunu göster (yeni kişiler konusunda gereksiz)
 */
export default function MessageBubble({ message, palette, showChannel = true }) {
  const mine = isMine(message);
  // Yeni kişi mesajları (direction alanlı) her zaman WhatsApp'tır
  const whatsapp = message.channel === "whatsapp" || Boolean(message.direction);
  return (
    <Box sx={{ display: "flex", flexDirection: "column", alignItems: mine ? "flex-end" : "flex-start", mb: 1 }}>
      {mine && message.senderName ? (
        <Typography sx={{ fontSize: TYPO.caption, color: COLORS.slate400, mb: 0.25, px: 0.5 }}>
          {message.senderName}
        </Typography>
      ) : null}
      <Box
        sx={{
          maxWidth: { xs: "85%", md: "70%" },
          px: 1.5,
          py: 1,
          borderRadius: 2.5,
          borderBottomRightRadius: mine ? 6 : undefined,
          borderBottomLeftRadius: mine ? undefined : 6,
          bgcolor: mine ? alpha(palette.primary, 0.1) : COLORS.slate100,
          color: COLORS.slate800,
          fontSize: TYPO.body,
          lineHeight: 1.55,
          whiteSpace: "pre-wrap",
          overflowWrap: "anywhere",
        }}
      >
        {message.text}
      </Box>
      <Typography
        component="div"
        sx={{ fontSize: TYPO.caption, color: COLORS.slate400, mt: 0.25, px: 0.5, display: "flex", alignItems: "center" }}
      >
        {showChannel && message.channel === "whatsapp" ? (
          <Tooltip title="WhatsApp">
            <WhatsAppIcon aria-label="WhatsApp" sx={{ fontSize: 13, mr: 0.5, color: COLORS.successDark }} />
          </Tooltip>
        ) : null}
        {timeOf(message.createdAt)}
        {mine && whatsapp ? <WaTicks status={waStatusOf(message)} /> : null}
        {mine && !whatsapp && message.readAt ? " · Okundu" : ""}
      </Typography>
    </Box>
  );
}
